export const isUrl = (value?: string | null): boolean => {
  if (!value) return false;

  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

export const toHttpUrl = (value?: string | null): string | undefined => {
  if (!value) return undefined;

  try {
    const { protocol } = new URL(value);

    return protocol === 'https:' || protocol === 'http:' ? value : undefined;
  } catch {
    return undefined;
  }
};

const ID_SEGMENT = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export const toPathPattern = (url: string): string => {
  const segments = new URL(url).pathname
    .split('/')
    .filter(Boolean)
    .map((segment) => (ID_SEGMENT.test(segment) ? ':id' : segment));

  return `/${segments.join('/')}`;
};
